'use client'

import { Grid, Typography } from '@mui/material'

// Types
import { DiamondProps } from '@/types/components/molecules/items/diamond'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

const DiamondMoelcule = (props: DiamondProps) => {
	// Props
	const { lng, title, description, icon, rotate, reverse } = props

	// Variables
	const { t } = useTranslation(lng)

	return (
		<Grid size={{ xs: 6, sm: 4, md: 2 }}>
			<Grid container>
				<Grid
					size={12}
					display="inline-flex"
					justifyContent="center"
					position="relative"
					sx={{
						'& .MuiSvgIcon-root': {
							position: 'absolute',
							top: '50%',
							left: '50%',
							fontSize: 36,
							transform: 'translate(-50%, -50%)'
						},
						'& picture': {
							display: 'inline-flex',
							width: 1,
							maxWidth: { md: 180 },
							'& img': {
								width: 1,
								height: 'auto',
								transform: `rotate(${rotate}deg)${reverse ? ' scaleX(-1)' : ''}`,
								transformOrigin: 'center'
							}
						}
					}}
				>
					<picture>
						<img src="/images/items/diamond.png" alt={title} />
					</picture>

					{icon}
				</Grid>

				<Grid size={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" px={{ xs: 2, md: 4 }} textAlign="center">
					<Typography
						component="h3"
						width={1}
						fontSize={{ xs: 16, md: 25 }}
						fontWeight={900}
						lineHeight={1.14}
						textOverflow="ellipsis"
						whiteSpace="nowrap"
						overflow="hidden"
						sx={{}}
					>
						{t(title)}
					</Typography>

					<Typography
						component="div"
						display="-webkit-box"
						width={1}
						mt={2}
						fontSize={12}
						fontWeight={700}
						lineHeight={1.14}
						textOverflow="ellipsis"
						overflow="hidden"
						sx={{
							WebkitBoxOrient: 'vertical',
							boxOrient: 'vertical',
							WebkitLineClamp: 3,
							lineClamp: 3
						}}
					>
						{t(description)}
					</Typography>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default DiamondMoelcule
